module.exports = __webpack_public_path__ + "img/rating-smiley-3.bd9a1c3c.svg";